var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "select",
      class: ["multi-select", _vm.modify, { "is-open": _vm.isOpen }]
    },
    [
      _c(
        "div",
        { staticClass: "multi-select__toggle", on: { click: _vm.toggleOpen } },
        [
          _c("span", { staticClass: "multi-select__caption" }, [
            _vm._v(_vm._s(_vm.placeholder))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "multi-select__fake-arrow" }, [
            _c("svg", { attrs: { width: "10", height: "6" } }, [
              _c("use", {
                attrs: { "xlink:href": "/webicons/sprite.svg#i-arr-down" }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade-filter", mode: "out-in" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMobile && _vm.isOpen,
                expression: "isMobile && isOpen"
              }
            ],
            ref: "fixedList",
            staticClass: "multi-select__fix"
          },
          [
            _c("div", {
              staticClass: "multi-select__fix-overlay",
              on: { click: _vm.closeFixedList }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "grid__container" }, [
              _c(
                "div",
                { staticClass: "multi-select__fix-content" },
                [
                  _vm.type === "checkbox"
                    ? _c("CheckboxList", {
                        attrs: { select: _vm.select, view: "mobile" },
                        on: { changeFilter: _vm.change }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "radio"
                    ? _c("RadioList", {
                        attrs: { select: _vm.select, view: "mobile" },
                        on: { changeFilter: _vm.change }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "multi-select__fix-submit",
                      on: { click: _vm.closeFixedList }
                    },
                    [_vm._v("Применить")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "div",
            {
              ref: "list",
              class: ["multi-select__list-wrap", { "is-top": _vm.isTop }],
              style: { height: _vm.heightList }
            },
            [
              _vm.type === "checkbox"
                ? _c("CheckboxList", {
                    attrs: { select: _vm.select, view: "desktop" },
                    on: { changeFilter: _vm.change }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "radio"
                ? _c("RadioList", {
                    attrs: { select: _vm.select, view: "desktop" },
                    on: { changeFilter: _vm.change }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }